import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div>
          <p className="footer__brand-name">Channel<span>MM</span></p>
          <p className="footer__brand-desc">
            Copyright © 2026 ChannelMM. All Rights Reserved. This website does
            not host any files on its servers. All videos and films remain the
            property of their respective copyright owners.
          </p>
        </div>

        <div>
          <p className="footer__col-title">Quick Links</p>
          <ul className="footer__col-links">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/movies/page/1">Movies</Link></li>
            <li><Link to="/tv-shows/page/1">Series</Link></li>
          </ul>
        </div>

        <div>
          <p className="footer__col-title">Support</p>
          <ul className="footer__col-links">
            <li><Link to="/contact">Contact Us</Link></li>
            <li><Link to="/feedback">Feedback</Link></li>
            <li><Link to="/community">Community</Link></li>
          </ul>
        </div>

        <div>
          <p className="footer__col-title">Legal</p>
          <ul className="footer__col-links">
            <li><Link to="/privacy">Privacy Policy &amp; Terms</Link></li>
            <li><Link to="/dmca">DMCA</Link></li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <p className="footer__copyright">
          © 2026 Channel MM Movies. All Rights Reserved. Made with ♥ for movie lovers
        </p>
        <span className="footer__version">Version 1.0.0</span>
      </div>
    </footer>
  );
}

export default Footer;
